import { render, staticRenderFns } from "./freeDeliveryConfigManage.vue?vue&type=template&id=4924f57c&scoped=true"
import script from "./freeDeliveryConfigManage.vue?vue&type=script&lang=js"
export * from "./freeDeliveryConfigManage.vue?vue&type=script&lang=js"
import style0 from "./freeDeliveryConfigManage.vue?vue&type=style&index=0&id=4924f57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924f57c",
  null
  
)

export default component.exports